import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import moment from "./plugins/moment";
import screen from "@/plugins/screen";
import title from "@/mixins/page-title";
import cognito from "@/js/cognito";
import authCheck from "@/mixins/auth-check";

Vue.mixin(title);
Vue.mixin(authCheck);

Vue.config.productionTip = false;

Vue.use(screen); // あとで削除

new Vue({
  router,
  store,
  vuetify,
  moment,
  cognito,
  render: h => h(App)
}).$mount("#app");

// バージョン確認用
window.projectVersion = process.env.VUE_APP_PROJECT_VERSION;